import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { scrollToHash } from '@/lib/scroll';

/**
 * Navigate to an on-page section anchor (e.g. "#services") from anywhere in the
 * app. On the home page it smooth-scrolls to the section, offset for the fixed
 * header. On any other route it routes home with the hash and useScrollToTop
 * performs the scroll once the home page has mounted.
 */
export function useSectionNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (href: string) => {
      const hash = href.startsWith('#') ? href : `#${href}`;
      if (location.pathname === '/') {
        scrollToHash(hash);
      } else {
        navigate(`/${hash}`);
      }
    },
    [navigate, location.pathname],
  );
}
